import { render, staticRenderFns } from "./InputAmount.vue?vue&type=template&id=504ccc63&scoped=true&"
import script from "./InputAmount.vue?vue&type=script&lang=js&"
export * from "./InputAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504ccc63",
  null
  
)

export default component.exports